import angular from 'angular'
import simulateErrorsController from './simulateErrors.ctrl'
import simulateErrorsTemplate from './simulateErrors.html'

export default angular.module('simulateErrors', ['ui.router'])
  .config(function ($stateProvider) {
    'ngInject'

    if (CONFIG.ALLOW_UNSAFE_ERROR_SIMULATION) {
      $stateProvider.state('app.simulateErrors', {
        url: '/simulate-errors',
        views: {
          content: {
            controller: simulateErrorsController,
            controllerAs: 'c',
            template: simulateErrorsTemplate
          }
        }
      })
    }
  })
